import { createSelector } from "reselect";
import { StoreState } from "Store/Reducers";
import { EntityId } from "../Entities/PropTypes";

const fetchEntities = ({settings}: StoreState) => settings.layouts;
const byEntityId = (_: StoreState, id: EntityId) => id;

export const isLayoutLoading = createSelector(
    fetchEntities,
    ({ _isFetching }) => _isFetching
)
export const isLayoutPatching = createSelector(
    fetchEntities,
    ({ _isPatching }) => _isPatching
);

export const isLayoutCreating = createSelector(
    fetchEntities,
    ({ _isCreating }) => _isCreating
);

export const isLayoutDeleting = createSelector(
    fetchEntities,
    ({ _isDeleting }) => _isDeleting
)

export const getLayoutsByEntityId = createSelector(
    fetchEntities,
    byEntityId,
    ({entities, byEntityId}, entity_id) => byEntityId?.[entity_id]?.map(i => entities?.[i])
);

export const getLayoutsByEntityIdAsObject = createSelector(
    fetchEntities,
    ({entities, byEntityId}) => Object.keys(byEntityId).reduce((acc, curr) => acc = {
        ...acc,
        [curr]: byEntityId?.[curr]?.map(j => entities?.[j])
    }, {})
);

export const getLayoutsByEntityTypeIdAsObject = createSelector(
    fetchEntities,
    ({ entities, byEntityType }) => Object.keys(byEntityType).reduce((acc, curr) => acc = {
        ...acc,
        [curr]: byEntityType
            ?.[curr]
            ?.map(j => entities?.[j])
            ?.sort((a: any, b: any) => +(a?.attributes?.order - b?.attributes?.order))
    }, {})
)

export const getLayoutsById = createSelector(
    fetchEntities,
    ({ entities }) => entities
)

export const getUsedFieldsInLayoutsByEntityId = createSelector(
    fetchEntities,
    byEntityId,
    ({ fieldsUsedByEntityId }, id) => fieldsUsedByEntityId?.[id]
);